export const PARAMETERS = 'md_parameters_GLOBAL';